import { Component, OnInit, Output, EventEmitter, AfterViewInit, AfterContentInit } from '@angular/core';
import { Order } from '../../../../Models/order';
import { MatDialog, MatDialogConfig } from "@angular/material";
import { DialogShowItemsComponent } from '../../../dialogs/dialog-show-items/dialog-show-items.component';
import { ItemShipDetail } from '../../../../Models/item-ship-detail';
import { ApiService } from '../../../../core/services/api.service';
import { Ship } from '../../../../Models/ship';
import { MessageService } from '../../../../core/services/message.service';
import { DialogShowStatusComponent } from '../../../dialogs/dialog-show-status/dialog-show-status.component';
import { ShipStatusEnum } from '../../../../enums/ship-status-enum';
import { Record } from '../../../../Models/record';
import { DialogStartIterateComponent } from '../../../dialogs/dialog-start-iterate/dialog-start-iterate.component';
import { Mark } from '../../../map/models/mark';
import { HttpParams } from '@angular/common/http';
import { Vehicle } from '../../../../Models/vehicle';
import { stagger } from '@angular/animations';
import { ShipTypeEnum } from '../../../../enums/ship-type-enum';
import { DialogShowJustificationsComponent } from '../../../dialogs/dialog-show-justifications/dialog-show-justifications.component';
import { DialogShowContactsComponent } from '../../../dialogs/dialog-show-contacts/dialog-show-contacts.component';
import { AlertTypeEnum } from '../../../../enums/alert-type-enum';
import { Router } from '@angular/router';

@Component({
  selector: 'delivery-driver',
  templateUrl: './delivery-driver.component.html',
  styleUrls: ['./delivery-driver.component.scss']
})

export class DeliveryDriverComponent implements OnInit, AfterViewInit, AfterContentInit {

  ngAfterContentInit(): void {
    this.openStart();
  }
  ngAfterViewInit(): void {

  }


  selectedStatus: any;
  activeShip: number = 0;
  @Output() notIterate = new EventEmitter<boolean>();
  pageSize: number = 4;
  start: number = 0;
  selectedVehicle: Vehicle;
  status = ShipStatusEnum;
  type = ShipTypeEnum;

  constructor(private dialog: MatDialog, private apiService: ApiService, private messageService: MessageService,
    private router: Router) {

  }

  ngOnInit(): void {

  }

  orders: Order[] = [];

  openStart() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    let dialogRef = this.dialog.open(DialogStartIterateComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        this.selectedVehicle = data;
        this.getOrders(this.start, this.pageSize);
      } else {
        this.router.navigate(['']);
      }
    });
  }

  openJustifications(ship: Ship) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    let dialogRef = this.dialog.open(DialogShowJustificationsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(data => {
      if (data) {
        ship.status = ShipStatusEnum.PENDING;
        ship.justifications.push(data);
        let temOrders: Order[] = [];
        let order = this.orders.splice(0, 1);
        temOrders.push(order[0]);
        temOrders.forEach(item => {
          this.orders.push(item);
        });
        if (this.orders[0].shipment.status == 3 || this.orders[0].shipment.status == 4) {
          this.start++;
          this.getOrders(this.start, this.pageSize);
        }
        this.apiService.put('api/ship', ship).subscribe((response:any) => {
          if (response.data)
            this.messageService.success('Éxito', 'Estatus de recolección modificado correctamente.');
        });
      }
    });
  }

  openItems(items: ItemShipDetail[]) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = items;
    this.dialog.open(DialogShowItemsComponent, dialogConfig);
  }

  openStatus(ship: Ship) {
    if (ship.status != ShipStatusEnum.ARRIVED) {
      
      let record = new Record();
      record.ship = ship;
      record.registerDate = new Date();
      record.status = ship.status;
      record.observation = 'Cambio de estatus.';

      this.apiService.post('api/record', record).subscribe(response => {

      });
      ship.status++;
      this.apiService.put('api/ship', ship).subscribe(response => {
        this.messageService.success('Éxito', 'Estatus de envío modificado correctamente.');
      });
    } else {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.disableClose = true;
      dialogConfig.autoFocus = false;
      dialogConfig.data = ship.shipType;

      let dialogRef = this.dialog.open(DialogShowStatusComponent, dialogConfig);
      dialogRef.afterClosed().subscribe(data => {
        if (data) {
          let record = new Record();
          record.ship = ship;
          record.registerDate = new Date();
          record.status = ship.status;
          record.observation = 'Cambio de estatus.';

          this.apiService.post('api/record', record).subscribe(response => {

          });
          ship.status = data;
          if (data == ShipStatusEnum.ABSENT_CLIENT || data == ShipStatusEnum.DELIVERED || data == ShipStatusEnum.RECOLECTED) {
            let temOrders: Order[] = [];
            let order = this.orders.splice(0, 1);
            temOrders.push(order[0]);
            temOrders.forEach(item => {
              this.orders.push(item);
            });
            if (this.orders[0].shipment.status == ShipStatusEnum.ABSENT_CLIENT ||
              this.orders[0].shipment.status == ShipStatusEnum.DELIVERED || this.orders[0].shipment.status == ShipStatusEnum.RECOLECTED
              || this.orders[0].shipment.status == ShipStatusEnum.PENDING) {
              this.start++;
              this.getOrders(this.start, this.pageSize);
            }
            if (data == ShipStatusEnum.DELIVERED) {
              this.sendNotificationClient(ship, AlertTypeEnum.DELIVERED_SHIP.toString());
            }
            if (data == ShipStatusEnum.RECOLECTED) {
              this.sendNotificationClient(ship, AlertTypeEnum.MERCHANDISE_DEVOLUTION.toString());
            }
          }
          this.apiService.put('api/ship', ship).subscribe(data => {
            this.messageService.success('Éxito', 'Estatus guardado correctamente.');
          }, error => {
            this.messageService.error('Error', 'Hubo un problema al guardar el estatus.');
            this.activeShip--;
          });

        }
      });
    }
  }

  sendNotificationClient(ship: Ship, alertType: string) {
    let params = new HttpParams();
    params = params.append("alertType", alertType);
    params = params.append("idClient", ship.shipmentClient.id.toString());
    params = params.append("shipId", ship.id.toString());
    this.apiService.post('api/alert/sendNotificationClient', null, params).subscribe(response => {

    });
  }

  saveRecord(record: Record) {
    this.apiService.post('api/record', record).subscribe(response => {

    });
  }

  getOrders(start: number, pageSize: number) {
    let params = new HttpParams();
    params = params.append("start", start.toString());
    params = params.append("pageSIze", pageSize.toString());
    params = params.append('vehicle', this.selectedVehicle.id.toString());
    this.apiService.get('api/ship/getOrdersByDriver', params).subscribe(response => {
      if (response.data) {
        if (this.orders.length == 0) {
          this.orders = response.data;
          let temOrders: Order[] = [];
          this.orders.forEach((item, index) => {
            if (this.orders[0].shipment.status == ShipStatusEnum.ABSENT_CLIENT || this.orders[0].shipment.status == ShipStatusEnum.DELIVERED
              || this.orders[0].shipment.status == ShipStatusEnum.RECOLECTED) {
              let orders = this.orders.splice(0, 1);
              temOrders.push(orders[0]);
            } else {
              return;
            }
          });
          temOrders.forEach(item => {
            this.orders.push(item);
          });
        }
        else {
          let cont = 0;
          let tem: Order[] = [];
          this.orders.forEach(item => {
            if (this.orders[cont].shipment.status == ShipStatusEnum.ABSENT_CLIENT || this.orders[cont].shipment.status == ShipStatusEnum.DELIVERED) {
              let orders = this.orders.splice(cont, this.orders.length - cont);
              tem = orders;
            }
            cont++;
          });
          this.orders = this.orders.concat(response.data);
          tem.forEach(item => {
            this.orders.push(item);
          });
        }
        if (this.orders.length == 0) {
          this.messageService.warning('Viajes', 'No se encontraron viajes para el camión ' + this.selectedVehicle.registerNumber, 8000);
          this.notIterate.emit(true);
        }
      }
    });
  }

  getStartMark(index: number) {
    let mark = undefined;
    if (index == 0) {
      if (this.orders[this.orders.length - 1].shipment.status == ShipStatusEnum.ABSENT_CLIENT || this.orders[this.orders.length - 1].shipment.status == ShipStatusEnum.DELIVERED
        || this.orders[this.orders.length - 1].shipment.status == ShipStatusEnum.RECOLECTED) {
        mark = {
          id: this.orders[this.orders.length - 1].nOrder,
          data: this.orders[this.orders.length - 1],
          lat: this.orders[this.orders.length - 1].shipment.destination ? this.orders[this.orders.length - 1].shipment.destination.latitude : 0,
          lng: this.orders[this.orders.length - 1].shipment.destination ? this.orders[this.orders.length - 1].shipment.destination.longitude: 0
        };
      } else {
        mark = {
          id: this.orders[index].nOrder,
          data: this.orders[index],
          lat: this.orders[index].shipment.destination ? this.orders[index].shipment.destination.latitude: 0,
          lng: this.orders[index].shipment.destination ? this.orders[index].shipment.destination.longitude: 0
        };
      }
      } else {
        mark = ({
          id: this.orders[index - 1].nOrder,
          data: this.orders[index - 1],
          lat: this.orders[index - 1].shipment.destination ? this.orders[index - 1].shipment.destination.latitude: 0,
          lng: this.orders[index - 1].shipment.destination ? this.orders[index - 1].shipment.destination.longitude: 0
        });
      }
    return mark;
  }
  getEndMark(index: number) {
    let mark = {
      id: this.orders[index].nOrder,
      data: this.orders[index],
      lat: this.orders[index].shipment.destination ? this.orders[index].shipment.destination.latitude: 0,
      lng: this.orders[index].shipment.destination ? this.orders[index].shipment.destination.longitude: 0
    };
    return mark;
  }

  public getEnumText(e: ShipStatusEnum): string {
    if (e == ShipStatusEnum.LOADED) {
      return 'GENERAL.ENUMS.SHIP_STATUS.LOADED';
    } else if (e == ShipStatusEnum.IN_TRANSIT) {
      return 'GENERAL.ENUMS.SHIP_STATUS.IN_TRANSIT';
    } else if (e == ShipStatusEnum.ARRIVED) {
      return 'GENERAL.ENUMS.SHIP_STATUS.ARRIVED';
    } else if (e == ShipStatusEnum.ABSENT_CLIENT) {
      return 'GENERAL.ENUMS.SHIP_STATUS.ABSENT_CLIENT';
    } else if (e == ShipStatusEnum.DELIVERED) {
      return 'GENERAL.ENUMS.SHIP_STATUS.DELIVERED';
    } else if (e == ShipStatusEnum.RECOLECTED) {
      return 'GENERAL.ENUMS.SHIP_STATUS.RECOLECTED';
    } else if (e == ShipStatusEnum.LANDING) {
      return 'GENERAL.ENUMS.SHIP_STATUS.LANDING';
    } else if (e == ShipStatusEnum.PENDING) {
      return 'GENERAL.ENUMS.SHIP_STATUS.PENDING';
    }

    return '';
  }

  public getShipTypeEnumText(e: ShipTypeEnum) {
    if (e == ShipTypeEnum.DELIVERY) {
      return 'DELIVERY_DRIVER.LABELS.TYPE_SHIP.SHIP';
    } else if (e == ShipTypeEnum.DEVOLUTION) {
      return 'DELIVERY_DRIVER.LABELS.TYPE_SHIP.RECOLECTION';
    }
    return '';
  }

  openContacts() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = false;
    dialogConfig.data = this.selectedVehicle.id;
    this.dialog.open(DialogShowContactsComponent, dialogConfig);
  }
}
